import styled from 'styled-components/macro'

const RowLabel = styled.span`
  font-weight: 300;
  margin-right: 24px;
`

export default RowLabel
